// extracted by mini-css-extract-plugin
module.exports = {"base":"LockEditor__base__1u814","lockIcon":"LockEditor__lockIcon__2GSU4","tooltipPopover":"LockEditor__tooltipPopover__eD_Xf"};